import { put, select } from 'redux-saga/effects'
import importer from 'common/importer'
const DonorsActions = importer('Stores/Donors/Actions')
import TagManager from 'react-gtm-module'
const { updateDonor } = importer('APIs/donors', null)
const { tokens } = importer('Stores/Users/Select', null)
export default function * main ({ id, donor, centerChanged }) {
  try {
    const _tokens = yield select(tokens)
    const { token_type, id_token } = _tokens
    const token = `${token_type} ${id_token}`
    yield put(DonorsActions.updateDonorLoading())
    const res = yield updateDonor(id, donor, token)
    if(centerChanged && res.status === 200){
      TagManager.dataLayer({
        dataLayer: {
          event: 'updateCenter',
          previousCenterName: null,
          centerId: donor?.donorDetails?.donationCenter
        }
      })
     }
    yield put(DonorsActions.updateDonorSuccess(res))
  } catch (error) {
    yield put(DonorsActions.updateDonorFailure(error))
  }
}
